export default (axios, checkHeaders) => ({
  getList (data = {}) {
    return axios.get('/equipments', { params: data.filters || {} })
  },
  postOne (data = {}) {
    return axios.post('/equipment', data.body, { params: data.filters || {} })
  },
  getOne (data = {}) {
    return axios.get('/equipment/' + data.id, { params: data.filters || {} })
  },
  patchOne (data = {}) {
    return axios.patch('/equipment/' + data.id, data.body, { params: data.filters || {} })
  },
  deleteOne (data = {}) {
    return axios.delete('/equipment/' + data.id, { params: data.filters || {} })
  },
})
